import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { AbstractControl, FormGroup } from '@angular/forms'

@Component({ template: '' })
export abstract class FormFieldComponent {
  @Input()
  label: string
  @Input()
  placeholder: string
  @Input()
  hint: string
  @Output()
  blurEvent: EventEmitter<any> = new EventEmitter()
  @Input()
  autocomplete = 'off'

  private formControl: AbstractControl

  @ViewChild('nativeElement')
  private nativeElementRef: ElementRef

  onBlurEvent(): void {
    this.blurEvent.emit()
  }

  @Input()
  set control(control: AbstractControl) {
    if (control instanceof FormGroup) {
      throw Error('illegal control input: an instance of FormGroup was detected.')
    }
    this.formControl = control
  }

  get control(): AbstractControl {
    return this.formControl
  }

  get errorMessage() {
    return this.control.errors ? Object.values(this.control.errors)[0] : null
  }

  get nativeElement() {
    return this.nativeElementRef.nativeElement
  }
}
